export default {
  addOns: 'アドオン',
  availability: '可用性',
  availabilityDaySelector: '空き状況の日付セレクター',
  unavailable: '利用不可',
  person: '人',
  people: '人々',
  reserveNow: '今すぐ予約',
  selectTime: '時間を選択',
  select: '選択',
  reserve: '予約する',
  time: '時間',
  tier: '層',
  questions: '質問',
  addToCart: 'カートに追加',
  checkout: 'チェックアウト',
  total: '合計',
  whatsIncluded: '含まれているもの',
  showMore: 'もっと見る',
  showLess: '表示を減らす',
  session: 'セッション',
  viewDetails: '詳細を見る',
  findAvailability: '可用性を確認',
  loading: '読み込み中',
  capacity: '容量',
  noAvailableSessionsOnThisDate: 'この日に利用可能なセッションはありません',
  noGroupAvailableOnThisDateAndTime:
    'この日付と時間には{{groupTitle}}は利用できません',
  noCollectionFound: 'コレクションが見つかりませんでした！',
  noResourceGroupFound: 'リソースグループが見つかりませんでした！',
  noData: 'データがありません！',
  continue: '続ける',
  night: '泊',
  nights: '泊',
  noAvailableSessionsForSelectedDates:
    '選択した日付の一部にセッションがありません。別の日付を選択してください。',
  from: 'から',
  dateRangeSelector: '日付範囲セレクター',
  priceTierRadioGroup: '価格階層ラジオボタングループ',
  startTime: '開始時間',
  duration: '利用時間',
  lengthOfStay: '滞在期間',
  startDate: '開始日',
  endDate: '終了日',
  selectDates: '日付を選択',
  more: 'その他',
  selectStartTime: '開始時間を選択',
  endTime: '終了時間',
  selectEndTime: '終了時間を選択',
  morning: '午前',
  afternoon: '午後',
  save: '保存',
  selectDuration: '利用時間を選択',
  forLength: '{{length}}分',
  moreDates: '他{{count}}件',
  addDate: '日付を追加',
  start: '開始',
  end: '終了',
  pickupFrom: 'お受け取り開始',
  returnBy: 'ご返却期限',
  day: '日',
  days: '日',
  hour: '時間',
  hours: '時間',
};
